import type { Media as MediaType } from '@/payload-types'

import { Media } from '@/components/Media'
import { Label } from '@/components/Grid/Label'
import clsx from 'clsx'
import React from 'react'

type Props = {
  active?: boolean
  isInteractive?: boolean
  label?: {
    amount: number
    position?: 'bottom' | 'center'
    title: string
  }
  media: MediaType
}

export const GridTileImage: React.FC<Props> = ({
  active,
  isInteractive = true,
  label,
  ...props
}) => {
  return (
    <div
      className={clsx(
        'group flex h-full w-full flex-col overflow-hidden rounded-lg border bg-white hover:border-[var(--neon-orange)] dark:bg-neutral-900',
        {
          'border-2 border-[var(--neon-orange)]': active,
          'border-neutral-200 dark:border-neutral-800': !active,
          relative: label,
        },
      )}
    >
      {props.media ? (
        <div className="relative flex-grow w-full overflow-hidden">
          <Media
            className={clsx('h-full w-full object-contain p-4 bg-white dark:bg-neutral-900', {
              'transition duration-300 ease-in-out group-hover:scale-105': isInteractive,
            })}
            height={80}
            imgClassName="h-full w-full object-contain"
            resource={props.media}
            width={80}
          />
        </div>
      ) : null}
      {label ? <Label amount={label.amount} position={label.position} title={label.title} /> : null}
    </div>
  )
}
